import { Globe } from 'lucide-react';
import type React from 'react';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

export type SupportedLanguage = 'en' | 'fr' | 'es' | 'de' | 'it';

interface LanguagePickerProps {
    selectedLanguage: SupportedLanguage;
    onLanguageChange: (language: SupportedLanguage) => void;
    className?: string;
}

const LANGUAGE_OPTIONS: { value: SupportedLanguage; label: string; flag: string }[] = [
    { value: 'en', label: 'English', flag: '🇬🇧' },
    { value: 'fr', label: 'Français', flag: '🇫🇷' },
    { value: 'es', label: 'Español', flag: '🇪🇸' },
    { value: 'de', label: 'Deutsch', flag: '🇩🇪' },
    { value: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const LanguagePicker: React.FC<LanguagePickerProps> = ({
    selectedLanguage,
    onLanguageChange,
    className = '',
}) => {
    return (
        <div className={`language-picker-container flex items-center gap-2 ${className}`}>
            <Globe className="h-4 w-4 text-gray-600" />
            <Select
                value={selectedLanguage}
                onValueChange={(value) => onLanguageChange(value as SupportedLanguage)}
            >
                <SelectTrigger className="w-[180px] bg-white/90 backdrop-blur-sm border-gray-300">
                    <SelectValue>
                        {(() => {
                            const selected = LANGUAGE_OPTIONS.find(
                                (opt) => opt.value === selectedLanguage
                            );
                            return selected ? (
                                <span className="flex items-center gap-2">
                                    <span>{selected.flag}</span>
                                    <span>{selected.label}</span>
                                </span>
                            ) : (
                                'Select Language'
                            );
                        })()}
                    </SelectValue>
                </SelectTrigger>
                <SelectContent className="bg-white border-gray-200">
                    {LANGUAGE_OPTIONS.map((option) => (
                        <SelectItem
                            key={option.value}
                            value={option.value}
                            className="hover:bg-gray-50"
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-lg">{option.flag}</span>
                                <span>{option.label}</span>
                            </div>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};

export default LanguagePicker;
